import Ajv from "ajv";
import { curry } from "lodash";

export const validator = curry(function(schema, data) {
  const ajv = new Ajv();
  const validate = ajv.compile(schema);
  const valid = validate(data);
  return valid;
});
